import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { oneOnOneLandingPageReactQueryKeys } from '../constants/oneOnOneReactQueryKeys';
import { getLandingPageactiveArchiveCount, getLandingPageData, oneOnOneLandingPageDetailsValidator } from '../services';

type OneOnOneLandingPage = z.infer<typeof oneOnOneLandingPageDetailsValidator>;

export const useOneOnOneLandingPageDetails = ({
  isArchivedList,
  dateRange,
  selectedCohortId,
  enabled = true,
  isShowReportees,
  employeedId = undefined,
}) =>
  useQuery(
    [
      oneOnOneLandingPageReactQueryKeys.oneOnOneLandingPageDetails,
      isArchivedList,
      dateRange,
      selectedCohortId,
      employeedId,
    ],
    () => getLandingPageData({ isArchivedList, dateRange, selectedCohortId, isShowReportees, employeedId }),
    {
      enabled,
    }
  );

export const useOneOnOneLandingActiveArchiveCount = ({ dateRange, selectedCohortId }) =>
  useQuery([oneOnOneLandingPageReactQueryKeys.oneOnOneActiveArchiveCount, dateRange, selectedCohortId], () =>
    getLandingPageactiveArchiveCount({
      selectedCohortId,
      dateRange,
    })
  );
